const IST_TIMEZONE = "Asia/Kolkata";

export const nowInIstForInput = (): string => {
  const now = new Date();
  const datePart = new Intl.DateTimeFormat("en-CA", {
    timeZone: IST_TIMEZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(now);
  const timePart = new Intl.DateTimeFormat("en-GB", {
    timeZone: IST_TIMEZONE,
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).format(now);
  return `${datePart}T${timePart}`;
};

export const dateToInputValue = (raw: string | null | undefined): string => {
  if (!raw) return "";
  return raw.replace(" ", "T").slice(0, 16);
};
